import React from 'react';
import { Box, Typography } from '@mui/material';

import styles from './ExportFileFilters.styles';
import DateRangePicker from '../../../../components/filters/DateRangePicker';

const ExportFileFilters = ({
  dateRange,
  setDateRange,
}) => {
  return (
    <Box sx={styles.filterRow}>
      <Box sx={styles.filterLeft}>
        <Typography sx={styles.filterLabel}>Date Filter:</Typography>
        <DateRangePicker dateRange={dateRange} setDateRange={setDateRange} />
      </Box>
    </Box>
  );
};

export default ExportFileFilters;
